import { render, staticRenderFns } from "./KidFamily.vue?vue&type=template&id=34a7c492&scoped=true&"
import script from "./KidFamily.vue?vue&type=script&lang=js&"
export * from "./KidFamily.vue?vue&type=script&lang=js&"
import style0 from "./KidFamily.vue?vue&type=style&index=0&id=34a7c492&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a7c492",
  null
  
)

export default component.exports